module.exports = __webpack_public_path__ + "media/images/common/ogp-3890bfda42b249107b71e409ff5886c7.png";